module.exports = "query Health {\n  health\n}\n"